import { Checkbox } from "@mui/material";
import { useEffect, useState } from "react";
import { components, ControlProps, InputProps } from "react-select";
import styled from "styled-components";
import theme from "../styles/theme";
import Status from "../types/enum/Status";
import Button from "./Button";
import FlexBox, { FlexGrow } from "./FlexBox";
import { ClickableIcon } from "./Icon";
import MinimalSelect from "./MinimalSelect";
import Modal from "./Modal";
import { StyledText } from "./Text";

const Title = styled.div`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
type FilterModalProps = {
  isOpen?: boolean;
  modalHeader: string;
  mobile: boolean;
  filterData: Array<any>;
  myCompetencyChecked: boolean;
  filters: Array<any>;
  setFilters: any;
  inset?: string;
  setOpen: (x: boolean) => void;
  confirmFunction: (data: any, dat2: any) => void;
  setIsTypeFiltered: (x: boolean) => void;
  isTypeFiltered: boolean;
};
const FilterModal = ({
  isOpen,
  modalHeader,
  filterData,
  myCompetencyChecked,
  mobile,
  filters,
  setFilters,
  inset,
  setOpen,
  confirmFunction,
  isTypeFiltered,
  setIsTypeFiltered,
}: FilterModalProps): JSX.Element => {
  const [selectedFilters, setSelectedFilters] = useState<Array<any>>([]);
  const [competencyFilterChecked, setCompetencyFilterChecked] =
    useState<boolean>(myCompetencyChecked);
  useEffect(() => {
    setSelectedFilters(filters);
  }, [filters]);
  const setAllFilters = () => {
    const index: any = [];
    filterData.forEach((element) => {
      index.push(element.value);
    });
    setSelectedFilters(index);
    // setCompetencyFilterChecked(true);
  };
  const setNoFilters = () => {
    setSelectedFilters([]);
    // setCompetencyFilterChecked(false);
  };
  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: {
            background: "unset",
          },
          content: {
            maxWidth: mobile ? "300px" : "360px",
            width: "100%",
            height: "auto",
            padding: "16px 16px 24px 16px",
            background: "#1a1d2d",
            // backdropFilter: 'blur(35px)',
            boxShadow: "0 0 4px black",
            position: "absolute",
            inset: inset || "0px 0px auto auto",
            margin: `calc(${theme.navbarHeight} + ${theme.spacing.x10} + 70px) 2% auto calc(${theme.spacing.x4} + 130px)`,
          },
        }}
      >
        <FlexBox justify="end">
          {isTypeFiltered && (
            <span
              onClick={() => {
                const index: any = [];
                filterData.forEach((element) => {
                  index.push(element.value);
                });
                setOpen(false);
                setIsTypeFiltered(false);
                setFilters(index);
                setOpen(false);
              }}
              style={{
                color: "#f7b53a",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <ClickableIcon
                mr={1}
                onClick={() => {}}
                color="#f7b53a"
                name="redo"
              />
              Reset to All
            </span>
          )}
        </FlexBox>
        <FlexBox
          alignItems="flex-start"
          style={{ maxHeight: "500px", overflowY: "auto" }}
          className="visible-scrollbar"
        >
          <FlexGrow>
            {filterData.map((filter) => (
              <FlexBox>
                <FlexGrow style={{ flexGrow: "0" }}>
                  <Checkbox
                    // defaultChecked={filters.includes(filter.value)}
                    checked={selectedFilters.includes(filter.value)}
                    onChange={(e) => {
                      e.target.checked
                        ? setSelectedFilters((current) => [
                            ...current,
                            filter.value,
                          ])
                        : setSelectedFilters(
                            selectedFilters.filter(
                              (item) => item !== filter.value
                            )
                          );
                    }}
                    sx={{
                      color: "#FAFAFA",
                      "&.Mui-checked": {
                        color: "#FAFAFA",
                      },
                    }}
                  />
                </FlexGrow>
                <FlexGrow>
                  <StyledText>{filter.label}</StyledText>
                </FlexGrow>
              </FlexBox>
            ))}
          </FlexGrow>
        </FlexBox>

        <FlexBox
          justify="end"
          style={{ marginTop: "16px", flexWrap: "nowrap" }}
        >
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              style={{
                width: mobile ? "150px" : "150px",
                height: "40px",
                padding: "13px 12px",
              }}
              isOutline
              onClick={() => {
                setOpen(false);
              }}
              status={Status.default}
            >
              Cancel
            </Button>
          </FlexGrow>
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              style={{
                width: mobile ? "150px" : "150px",
                height: "40px",
                padding: "13px 12px",
              }}
              status={Status.button}
              onClick={() => {
                confirmFunction(selectedFilters, competencyFilterChecked);
              }}
            >
              Apply
            </Button>
          </FlexGrow>
        </FlexBox>
      </Modal>
    </>
  );
};

export default FilterModal;
